import React from 'react';

import './Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <div className="APIS-swap-footer">
        <div className="APIS-swap-footer-content">
          <div className="APIS-swap-footer-left">
            <img className="APIS-swap-footer-logo" src={require("../../Asset/APIS_swap_logo.png")}/>
            <p className="APIS-swap-footer-text">apis_official@apisplatform.io<br/>Copyright © The Oxchild Pte Ltd. All Rights Reserved.</p>
          </div>
          <div className="APIS-swap-footer-right">
            <img className="APIS-swap-footer-redirect" src={require("../../Asset/youtube_icon.png")} onClick={()=>{window.location.href = "https://www.youtube.com/channel/UCArVzPjkC_BrqkjFG3DZOjQ"}}/>
            <img className="APIS-swap-footer-redirect" src={require("../../Asset/medium_icon.png")} onClick={()=>{window.location.href = "https://medium.com/apisplatform"}}/>
            <img className="APIS-swap-footer-redirect" src={require("../../Asset/twitter_icon.png")} onClick={()=>{window.location.href = "https://twitter.com/Apis11Official"}}/>
            <img className="APIS-swap-footer-redirect" src={require("../../Asset/telegram_icon.png")} onClick={()=>{window.location.href = "https://t.me/TheApisplatform"}}/>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer;